import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button, Grid, IconButton } from "@mui/material";
import CardContainer from "../../../commons/cards/CardContainer";
import { tableStyles } from "../../../commons/table/tableConfig";
import { StyledEstablecimientos } from "../../../styled/Prevencion";
import AyudaLabelPresentacion from "./labels/AyudaLabelPresentacion";
import HeaderLabelPresentacion from "./labels/HeaderLabelPresentacion";
import FormulariosPresentacionCard from "./cards/FormulariosPresentacionCard";
import { Add } from "@mui/icons-material";

const DetallePresentacionRes81 = ({
  presentacion,
  formulariosPresentacion,
  handleVolver,
  handleVerFormulario,
  handleEditarFormulario,
  handleCertificado,
  handleNuevoFormulario,
  showNuevoFormulario,
}) => {
  return (
    <>
      <Grid container spacing={2} sx={{ marginBottom: 2 }}>
        <Grid item xs={12}>
          <IconButton onClick={handleVolver} sx={{ color: "black" }}>
            <ArrowBackIcon fontSize="large" />
          </IconButton>
        </Grid>
      </Grid>
      <HeaderLabelPresentacion presentacion={presentacion} />
      <AyudaLabelPresentacion />

      {showNuevoFormulario && (
        <Grid container justifyContent="flex-end" sx={{ marginTop: 2, marginBottom: 2 }}>
          <Button variant="contained" color="primary" onClick={handleNuevoFormulario}>
            <Add /> Nuevo Formulario
          </Button>
        </Grid>
      )}

      <CardContainer
        title="FORMULARIOS RES. 81/19"
        loading={formulariosPresentacion.loading}
        componenteSubtitulo={
          <StyledEstablecimientos.StickyCard
            elevation={2}
            sx={tableStyles.headerStyle}
          >
            <Grid container spacing={2}>
              <Grid item xs={1}>Fecha Presentación</Grid>
              <Grid item xs={2}>Establecimiento</Grid>
              <Grid item xs={2}>Domicilio</Grid>
              <Grid item xs={1} sx={{ display: "flex", justifyContent: "center", textAlign: "center" }}>Establecimiento Empresa (MU)</Grid>
              <Grid item xs={1} sx={{ display: "flex", justifyContent: "center", textAlign: "center" }}>Codigo Establecimiento</Grid>
              <Grid item xs={1} sx={{ display: "flex", justifyContent: "center", textAlign: "center" }}>Establecimiento SRT (Int)</Grid>
              <Grid item xs={1} sx={{ display: "flex", justifyContent: "center", textAlign: "center" }}>Es de Terceros</Grid>
              <Grid item xs={1} sx={{ display: "flex", justifyContent: "center", textAlign: "center" }}>Fecha Baja</Grid>
              <Grid item xs={1} sx={{ display: "flex", justifyContent: "center", textAlign: "center" }}>Estado</Grid>
              <Grid item xs={1} sx={{ display: "flex", justifyContent: "center" }}>Operaciones</Grid>
            </Grid>
          </StyledEstablecimientos.StickyCard>
        }
        componente={
          <FormulariosPresentacionCard
            data={formulariosPresentacion.data}
            loading={formulariosPresentacion.loading}
            handleVerFormulario={handleVerFormulario}
            handleEditarFormulario={handleEditarFormulario}
            handleCertificado={handleCertificado}
          />
        }
      />
    </>
  );
};

export default DetallePresentacionRes81;
